<template>
    <Label :text="descricao" :theme="config.theme" :icon="config.icon" />
</template>

<script>
    import Label from '@/components/Label.vue'

    export default {
        name: 'LabelSituacaoAcademica',
        props: {
            codigo: String,
            descricao: String
        },
        data() {
            return {
                config: {
                    theme: "primary",
                    icon: "done"
                }
            }
        },
        components: {
            Label
        },
        created() {
            switch (this.codigo) {
                case "C": this.config = { theme: 'primary', icon: 'done' }; break; //Cursando
                case "F": this.config = { theme: 'success', icon: 'school' }; break; //Formado
                case "P": this.config = { theme: 'primary', icon: 'block' }; break; //Período de matrícula

                case "T": this.config = { theme: 'warning', icon: 'lock_outline' }; break; //Matrícula trancada
                case "R": this.config = { theme: 'warning', icon: 'sync_alt' }; break; //Transferido
                case "S": this.config = { theme: 'warning', icon: 'sync_alt' }; break; //Solicitou transferencia
                case "N": this.config = { theme: 'warning', icon: 'hourglass_empty' }; break; //Não rematriculado
                case 'M': this.config = { theme: 'warning', icon: 'info' }; break; //Término de contrato

                case "D": this.config = { theme: 'danger', icon: 'error_outline' }; break; //Desistente
                case "E": this.config = { theme: 'danger', icon: 'remove_circle_outline' }; break; //Matrícula cancelada
                case "X": this.config = { theme: 'danger', icon: 'block' }; break; //Expulso

                default: this.config = { theme: 'default', icon: 'label' }; break;
            }
        }
    }
</script>

<style scoped>
</style>
